import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Stack,
    Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import DescriptionIcon from '@mui/icons-material/Description';

const GupshupCsvHelpAccordion = () => {
    return (
        <Box mt={3}>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <InfoOutlinedIcon />
                        <Typography fontWeight={600}>
                            Requisitos del archivo CSV y plantilla
                        </Typography>
                    </Stack>
                </AccordionSummary>

                <AccordionDetails>
                    <Stack spacing={2}>
                        {/* CSV */}
                        <Box>
                            <Typography fontWeight={600}>
                                📄 Archivo CSV
                            </Typography>
                            <Typography variant="body2">
                                El archivo debe ser <b>CSV</b> y debe contener:
                                <br />• <b>name</b>: nombre del contacto
                                <br />• <b>phone</b>: número de WhatsApp
                            </Typography>
                        </Box>

                        {/* Params */}
                        <Box>
                            <Typography fontWeight={600}>
                                🧩 Variables del mensaje
                            </Typography>
                            <Typography variant="body2">
                                Puedes usar hasta <b>4 variables</b>:
                                <br />
                                • param1, param2, param3, param4
                                <br />
                                Estas variables deben existir en la plantilla de
                                Gupshup.
                            </Typography>
                        </Box>

                        {/* Media */}
                        <Box>
                            <Typography fontWeight={600}>
                                📎 Archivo adjunto (solo uno)
                            </Typography>

                            <Stack spacing={1} mt={1}>
                                <Stack direction="row" spacing={1}>
                                    <ImageIcon fontSize="small" />
                                    <Typography variant="body2">
                                        <b>Imagen</b>: columna <b>imageUrl</b>
                                        <br />
                                        URL pública y accesible.
                                    </Typography>
                                </Stack>

                                <Stack direction="row" spacing={1}>
                                    <VideoLibraryIcon fontSize="small" />
                                    <Typography variant="body2">
                                        <b>Video</b>: columna <b>videoUrl</b>
                                        <br />
                                        URL pública directa (no YouTube).
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="flex-start"
                                >
                                    <DescriptionIcon fontSize="small" />
                                    <Typography variant="body2">
                                        <b>Documento</b> (deben existir las 3
                                        columnas):
                                        <br />• <b>documentLink</b>: URL pública
                                        del archivo
                                        <br />• <b>documentFilename</b>: nombre
                                        con el que se enviará
                                        <br />• <b>documentTemplate</b>:
                                        plantilla de Gupshup para el documento
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Box>

                        {/* Warning */}
                        <Typography variant="body2" color="error">
                            ⚠️ No se pueden combinar imagen, video y documento.
                            <br />
                            El tipo de archivo debe estar configurado en la
                            plantilla de Gupshup.
                        </Typography>
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default GupshupCsvHelpAccordion;
